<script setup lang="ts">
import {
  floorFitness,
  floorOther,
  phoneFitness,
  phoneOther,
  textFitness,
  textOther,
} from '.';

const email = 'info@okgym.cz';
</script>

<template>
  <div class="flex flex-col divide-y divide-[#E1E1E1]">
    <FooterContentContactLink
      :to="`mailto:${email}`"
      :text="email"
      class="pb-r6"
    />
    <div class="text-client-black py-r6 gap-r3 flex flex-col">
      <AppParagraph class="font-medium! xl:max-w-sm">
        <AppText size="md" class="text-client-orange">
          {{ floorFitness }}
        </AppText>
        {{ textFitness }}
      </AppParagraph>
      <FooterContentContactLink
        :to="`tel:${phoneFitness.replace(/\s/g, '')}`"
        :text="phoneFitness"
      />
    </div>
    <div class="text-client-black py-r6 gap-r3 flex flex-col max-xl:last:pb-0">
      <AppParagraph class="font-medium! xl:max-w-sm">
        <AppText size="md" class="text-client-orange">
          {{ floorOther }}
        </AppText>
        {{ textOther }}
      </AppParagraph>
      <FooterContentContactLink
        :to="`tel:${phoneOther.replace(/\s/g, '')}`"
        :text="phoneOther"
      />
    </div>
  </div>
</template>
